/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Plh_Confirm_CancelInputs */

const vi_sl_plh_confirm_cancel = /** @type {(inputs: Sl_Plh_Confirm_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hủy phiếu lấy hàng này?`)
};

/**

* @param {Sl_Plh_Confirm_CancelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_plh_confirm_cancel = /** @type {((inputs?: Sl_Plh_Confirm_CancelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Plh_Confirm_CancelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_plh_confirm_cancel(inputs)
});